import React from "react";
import {Box, Grid, Card, Typography} from "@mui/material";
import {KpiDonutChart} from "../../components/kpiCharts/KpiDonutChart";

export const KpiChartsSection = ({statistics, loading = false}) => {
    const {
        leadsCount = 0,
        leadsCountIsManualFalse = 0,
        leadsCountIsManualTrue = 0,
        totalWebAndPhoneConverted = 0,
        totalWebConverted = 0,
        totalPhoneConverted = 0,
        leadSalesPerson = 0,
        leadConvertedTodayIsManual = 0,
        leadConvertedTodayIsntManual = 0,
    } = statistics;

    const phoneLeadsCount = leadsCountIsManualTrue - leadSalesPerson;

    return (
        <Box sx={{mb: 3}}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{p: 0, borderRadius: 2, height: '100%', boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'}}>
                        <KpiDonutChart
                            title="Total Web + Phone"
                            totalLabel="Total Leads"
                            totalValue={leadsCount}
                            series={[
                                leadsCount - totalWebAndPhoneConverted,
                                totalWebAndPhoneConverted
                            ]}
                            loading={loading}
                        />
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{p: 0, borderRadius: 2, height: '100%', boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'}}>
                        <KpiDonutChart
                            title="Web Leads"
                            totalLabel="Total Leads"
                            totalValue={leadsCountIsManualFalse}
                            series={[
                                leadsCountIsManualFalse - totalWebConverted,
                                totalWebConverted
                            ]}
                            loading={loading}
                        />
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{p: 0, borderRadius: 2, height: '100%', boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'}}>
                        <KpiDonutChart
                            title="Phone Leads"
                            totalLabel="Total Leads"
                            totalValue={phoneLeadsCount}
                            series={[
                                phoneLeadsCount - totalPhoneConverted,
                                totalPhoneConverted
                            ]}
                            loading={loading}
                        />
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{p: 0, borderRadius: 2, height: '100%', boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'}}>
                        <KpiDonutChart
                            title="Delayed Phone + Web"
                            totalLabel="Total"
                            totalValue={leadsCount}
                            series={[
                                leadsCount - (leadConvertedTodayIsManual + leadConvertedTodayIsntManual),
                                leadConvertedTodayIsManual + leadConvertedTodayIsntManual
                            ]}
                            loading={loading}
                        />
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{p: 0, borderRadius: 2, height: '100%', boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'}}>
                        <KpiDonutChart
                            title="Delayed Web"
                            totalLabel="Total Leads"
                            totalValue={leadsCountIsManualFalse}
                            series={[
                                leadsCountIsManualFalse - leadConvertedTodayIsntManual,
                                leadConvertedTodayIsntManual
                            ]}
                            loading={loading}
                        />
                    </Card>
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{
                        borderRadius: 2, 
                        height: '100%', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        minHeight: '300px',
                        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'
                    }}>
                        <Typography variant="h6" fontWeight={600} fontSize="18px" color="#2B3033" mb={3} textAlign="center">
                            Leads created by the Sales rep
                        </Typography>
                        <Typography variant="h3" fontWeight={700} color="#ff3b80" fontSize="48px">
                            {leadSalesPerson}
                        </Typography>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

